import { IAgencyCouponData, IAgencyRewardData } from './UserContextModels';

export async function GetAgencies(): Promise<any[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetAgentAgencies`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetApplicationAccess(): Promise<string[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetApplicationAccess`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetSecurityGroups(): Promise<string[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetSecurityGroups`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetUserGroups(): Promise<string[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetUserGroups`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetMarketingInitiatives(): Promise<any[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetAgentMarketingInitiatives`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}
export async function GetUserCampaigns(resetCache: boolean = false, userId: string, channel: string, userStatus: string | null = null, initiativeStatus: string | null = null, initiativeType: string | null = null): Promise<any[]> {
  try {
    const params = new URLSearchParams();
    params.append('userId', userId);
    params.append('channel', channel);
    if (userStatus !== null) {
      params.append('userStatus', userStatus);
    }
    if (initiativeStatus !== null) {
      params.append('initiativeStatus', initiativeStatus);
    }
    if (initiativeType !== null) {
      params.append('initiativeType', initiativeType);
    }
    params.append('resetCache', String(resetCache));
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetUserCampaigns?${params.toString()}`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}
export async function GetAgencyRewards(): Promise<IAgencyRewardData[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetAgencyRewards`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}
export async function GetProducerPerformance(): Promise<IProducerPerformance | undefined> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetProducerPerformance`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const text = await res.text();
        if (text) {
          const data: any | null = JSON.parse(text);
          return data;
        }
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return undefined;
}
export async function GetAgencyCoupons(): Promise<IAgencyCouponData[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetAgencyCoupons`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}
